export function countPlainTextLength(htmlString: string | null): number {
    if (!htmlString) return 0; // Return 0 if null or empty

    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlString;
    const plainText = tempElement.textContent || tempElement.innerText || '';
    return plainText.length;
  }